<template>
    <div class="content min-vh-100 flex-column d-flex justify-content-between">
        <section>
            <h2 class="title">
                CONTACT US
            </h2>
            <hr />
            <div class="row justify-content-center">
                <div class="col-12 col-md-10 col-lg-8">
                    <h3 class="text-md-center">HOW CAN WE HELP?</h3>
                    <p class="text-md-center">LET US KNOW WHICH IS YOUR EMERGENCY AND WE WILL CONTACT YOU IMMEDIATELY AT THE MOBILE NUMBER INDICATED BELOW</p> 
                </div>
            </div>
            <form @submit.prevent="sendMessage">
                <div class="row justify-content-center">
                    <div class="col-12 col-md-10 col-lg-8">
                        <div class="form-group">
                            <label for="event_place">Event Location (Indicate place where you are at the time of the request (country/city))</label>
                            <input v-model="form.event_place" type="text" class="form-control" :class="{ 'is-invalid':  $v.form.event_place.$error }">
                            <div class="invalid-feedback" v-if="!$v.form.event_place.required">Field is required</div>
                        </div>
                    </div>
                    <div class="col-12 col-md-10 col-lg-8">
                        <div class="form-group">
                            <label for="message">Your message:</label>
                            <textarea v-model="form.message" type="text" class="form-control" :class="{ 'is-invalid': $v.form.message.$error }" rows="3"
                                max-rows="6">
                            </textarea>
                            <div class="invalid-feedback" v-if="!$v.form.message.required">Field is required</div>
                        </div>
                    </div>
                    
                    <div class="col-12 col-md-10 col-lg-8">
                        <div class="form-group">
                            <label for="title">Your mobile number:</label>
                            <input v-model="form.phone" type="text" class="form-control" :class="{ 'is-invalid': $v.form.phone.$error }"  placeholder="+39 123456789">
                            <div class="invalid-feedback" v-if="!$v.form.phone.required">Field is required</div>
                        </div>
                    </div>
                    <div class="col-12 col-md-10 col-lg-8">
                        <div class="row-btn">
                            <button type="submit" class="btn btn-primary" >Send</button>
                        </div>
                    </div>
                </div>
            </form>
        </section>    
    </div>
</template>

<script>
import api from '../http/api.js'
import { required  } from 'vuelidate/lib/validators'

export default {
    data(){
        return {
            form: {
                event_place: "",
                message: "",
                phone: this.$store.state.userInfo.phoneNumber, // default from anag
            }                      
        }
    },
    validations: {
        form: {
            event_place: {
                required,
            },
            message: {
                required,
            },
            phone: {
                required,
            }
        }
    },
    methods: {
        sendMessage(){
           
            api.get('/v1/me')
                .then((response) => {
                    
                    const v = this;

                    this.$v.$touch()
                    if (this.$v.$invalid) {
                        return false;
                    }
                    const gcontact = { 
                        from: this.$store.state.userInfo.email, 
                        from_name: this.$store.state.userInfo.name,
                        insurable_id: response.data.data.insurable_id,
                        anag_id: response.data.data.id,
                        policy_id: response.data.data.policy.id,  
                        ...this.form
                    }
                    console.log(gcontact);
                    
                    api.post('/v1/mins/emergency-email', gcontact)
                        .then(() => {
                            this.form = {
                                message: "",
                                phone: "", 
                            };
                            v.$v.$reset();

                            this.$router.push({ name: 'EmergencyEmailSuccess' });
                        })
                        .catch(() => {
                            //console.log(err);
                            v.$emit('show-message', {
                                type: 'danger',
                                text: "Oops! Something went wrong!"
                            });
                        });
                        // this.$store.commit('user_info', response.data.data)
                        // this.dob = response.data.data.infos.date_of_birth
                        // this.country = response.data.data.infos.country
            
                }, () => {
                    //console.log(error);
                }); 
            

            
        },

        fetchData () {
            //console.log("fetchData");
            this.error = this.profile = null

           
    }

    }
}
</script>